import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "@/lib/constants";
import type { Brand } from "@shared/schema";

interface BrandWithStatus extends Brand {
  active?: boolean;
}

export function useBrands() {
  return useQuery<Brand[]>({
    queryKey: ["brands"],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/brands`);
      if (!res.ok) {
        throw new Error("Failed to fetch brands");
      }
      const data = await res.json();
      const items = Array.isArray(data) ? data : data.items || [];
      return (items as BrandWithStatus[])
        .filter(b => b.active !== false)
        .map(b => {
          const name = (b as any).name ?? String(b);
          return {
            ...b,
            id: String((b as any).id ?? name),
            name,
            slug: (b as any).slug ?? name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
            logo: (b as any).logo ?? (b as any).image ?? null,
          };
        });
    },
  });
}
